import React from 'react';
import PropTypes from 'prop-types';
import { toLower } from 'lodash';
import { formatSalePrice } from '../../../utils/money';

const StudFee = ({ data }) => {
    if (!data || !data.length) { return null; }

    const {
        nominationFee,
        studFeeCondition,
        curCode,
        nominationYear,
    } = data[0];

    const nomination = toLower(studFeeCondition) === 'private' ?
        'Private' : formatSalePrice(nominationFee, curCode);

    return nomination === '—' ? null : (
        <span className="hp-nameRow__studFee">
            <span className="hp-nameRow__studFee__value">
                {nomination}
            </span>
            {nominationYear && (
                <span className="hp-nameRow__studFee__label">
                    {nominationYear} stud fee
                </span>
            )}
        </span>
    );
};

StudFee.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        nominationFee: PropTypes.number,
        studFeeCondition: PropTypes.string,
        curCode: PropTypes.string,
        nominationYear: PropTypes.number,
    })),
};

export default StudFee;



// WEBPACK FOOTER //
// ./src/js/horse/nameRow/components/StudFee.jsx